var NoInfoNotice = () => <td className='cs_no_info'>No information available yet from 3rd party contact database.</td>;

export default NoInfoNotice;
  